import { Container } from "reactstrap"
import Breadcrumb from 'Components/organisms/breadcrumb';
import EmptyState from "Components/organisms/empty-state";


const UnAuthorizedPage = () => {
    return <div className="page-content">
        <Container fluid>
            <Breadcrumb
                title="Unauthorized"
                breadcrumbItem="Not Allowed"
            />
            <EmptyState
                title={"Unauthorized"}
                subtitle={"You are not allowed to access this page. Please contact your system admin"}
            />
        </Container>
    </div>
}

export default UnAuthorizedPage